{
  "version": 1,
  "asset_id": "73a3cbe4-7015-4e08-933b-5b342394900d",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/73a3cbe4-7015-4e08-933b-5b342394900d/over-ons-640.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/73a3cbe4-7015-4e08-933b-5b342394900d/over-ons-640.avif",
  "original_filename": "over-ons-640.avif",
  "size": 19966,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:44Z"
}
